import { api } from '../../api';
import { useMutation, UseMutationResult } from 'react-query';
import queryClient from '../../query-client';
import { AxiosError } from 'axios';
import { useFirmContext } from '../../providers/FirmProvider';

async function activateSubscription(firmId: string): Promise<void> {
    await api.post(`/firms/${firmId}/subscription/v2/activate`);
}

export function useActivateSubscription(): UseMutationResult<void, AxiosError, void, unknown> {
    const { id } = useFirmContext();
    return useMutation(() => activateSubscription(id), {
        onSettled: () => {
            queryClient.invalidateQueries(['firm']);
            queryClient.invalidateQueries(['subscription']);
            queryClient.invalidateQueries(['prior-invoices']);
            queryClient.invalidateQueries(['upcoming-invoice']);
        },
    });
}
